// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1Tios","label":"Completed_label__1Wvou"};